import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { SEOLandingUpdate } from 'app/typings/SEOLanding';
import { apiMutation } from 'app/utils/request/api';

type PayloadProps = {
  slug: string;
  payload: SEOLandingUpdate;
};

export const useUpdateSEOLanding = () => {
  const queryClient = useQueryClient();

  return useMutation<SEOLandingUpdate, unknown, PayloadProps>({
    mutationFn: async ({ slug, payload }) =>
      apiMutation(
        'PUT',
        {
          path: `/landing${slug}`,
        },
        payload
      ),
    onSuccess: (_, { slug }) => {
      queryClient.invalidateQueries(['seoLanding', slug]);
    },
  });
};
